var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation"},[_c('Title',{attrs:{"chineseTitle":"运行监控","englishTitle":"operation monitoring and controlling"}}),_c('div',{staticClass:"operationContent"},[_c('data-item',{attrs:{"data":[
            {
                key: '有功功率',
                value: this.$store.state.MQTTObj[_vm.deviceName + 'PA'],
                unit: 'w',
            },{
                key: 'A相电流',
                value: this.$store.state.MQTTObj[_vm.deviceName + 'Ia'],
                unit: 'A',
            } ]}}),_c('data-item',{attrs:{"data":[
            {
                key: '不平衡度',
                value: this.$store.getters.unbalance(_vm.deviceName),
                unit: '%',
            },{
                key: 'B相电流',
                value: this.$store.state.MQTTObj[_vm.deviceName + 'Ib'],
                unit: 'A',
            } ]}}),_c('data-item',{attrs:{"data":[
            {
                key: '进线母排温度',
                value: this.$store.state.MQTTObj[_vm.deviceName + 'Temperature'],
                unit: '℃',
            },{
                key: 'C相电流',
                value: this.$store.state.MQTTObj[_vm.deviceName + 'Ic'],
                unit: 'A',
            } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }